export default "__VITE_ASSET__B1z5EA5m__"